import { createSelector } from 'reselect';
import CarrierM39ComplianceOperatorNumberColumns from '../../containers/CarrierM39ComplianceOperatorNumberColumns';
import CarrierM39ComplianceOperatorPercentageColumns from '../../containers/CarrierM39ComplianceOperatorPercentageColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.isLoading;

export const getData =
  ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.getDataFunction();

export const getPercentageColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.requestParams, CarrierM39ComplianceOperatorPercentageColumns);

export const getNumberColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.requestParams, CarrierM39ComplianceOperatorNumberColumns);
